import { UseQueryResult, useQuery } from "react-query";

import { ICart } from "../types";
import { carts } from "../utils/api";

import { useAuth } from "./useAuth";

export const useGetCartByCustomerId = (
    customerId: string | undefined,
    enabled: boolean,
    queryName = "fetchCart",
): UseQueryResult<ICart | null, unknown> => {
    const auth = useAuth();
    return useQuery<ICart | null, unknown>(
        [queryName, customerId],
        async (): Promise<ICart | null> => {
            if (!auth.token) {
                throw new Error(
                    "Cannot fetch cart without authorization token.",
                );
            }
            if (!customerId) {
                return null;
            }
            return await carts.getCartByCustomerId({
                customerId,
                token: auth.token,
            });
        },
        {
            enabled: typeof customerId !== "undefined" && enabled,
        },
    );
};
